import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, name, type }) => {
  return (
    <Helmet>
      {/* Standardní metadata */}
      <title>{title} | Scoreo</title>
      <meta name='description' content={description} />
      
      {/* Facebook / Open Graph */}
      <meta property="og:type" content={type || 'website'} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {/* Pokud máš URL, můžeš ji sem posílat také */}
      
      {/* Twitter */}
      <meta name="twitter:creator" content={name || "Scoreo"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}

export default SEO;